import translateStatus from './translateStatus'

const withdraws = {
  translateStatus,
}

export default withdraws
